import { CircularProgress } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import GridTableOverlay from 'components/shared/GridTableOverlay';
import EmptyGrid from 'icons/EmptyGrid';

interface WrapperProps {
  isError?: boolean;
  isLoading?: boolean;
}

const GridTableOverlayWrapper = ({ isError, isLoading }: WrapperProps) => {
  return (
    <GridTableOverlay
      icon={
        (isError ?? false) ? (
          <ErrorOutlineIcon />
        ) : (isLoading ?? false) ? (
          <CircularProgress />
        ) : (
          <EmptyGrid sx={{ width: 36, height: 36 }} />
        )
      }
      text={
        (isError ?? false)
          ? 'Something went wrong while fetching data...'
          : (isLoading ?? false)
            ? 'Waiting for data...'
            : 'No matching results'
      }
    />
  );
};

export default GridTableOverlayWrapper;
